export default __webpack_public_path__ + "static/media/Logo_1.1a0f469f.png";